import { render, staticRenderFns } from "./MsgIcon.vue?vue&type=template&id=4a35b2fb&"
import script from "./MsgIcon.vue?vue&type=script&lang=js&"
export * from "./MsgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports